/* ==========================================================================
   LEGIT: spend ladder bar inside the Rebuy Smart Cart
   --------------------------------------------------------------------------
   Config comes from window.LegitGift, set inline by sections/legit-gift-cart.liquid
   (header group). That script also remembers gated links (creatine) and the email
   deal for the visit, and has already sorted the tiers by threshold.

   Shows above the cart items:
     - next step:   "✓ Free shipping unlocked. You're $X away from a FREE Strawberry Melt"
     - ladder track with a marker per step (truck for shipping, tub for gifts)
     - everything:  "FREE SHIPPING + FREE MELT UNLOCKED"
   Hidden on an empty cart. Rebuy's own tiered bar is hidden with CSS (it keeps running,
   so the gift tier still adds and removes the tub).

   If a shopper bins an earned gift, Rebuy only offers "Re-Add" inside its own hidden
   bar, so we surface an "Add it back" button and forward the click.

   SAFETY: Rebuy is a Vue app and re-renders wipe injected nodes. The observer is
   disconnected before touching the DOM and reconnected after.
   ========================================================================== */
(function () {
  'use strict';
  var G = window.LegitGift || {};
  if (!G.enabled || !Array.isArray(G.tiers) || !G.tiers.length) return;
  var money = G.money;

  var STYLE =
    "[data-rebuy-component='progress-bar']{display:none!important}" +
    ".legit-cart-gift{padding:12px 16px 14px;background:#fff4e0;border-bottom:1px solid #f3dfb8;font-family:var(--FONT-STACK-BODY,'Roboto',-apple-system,sans-serif)}" +
    ".legit-cart-gift__row{display:flex;align-items:center;gap:12px}" +
    ".legit-cart-gift__h{flex:1;font-size:13px;font-weight:800;line-height:1.35;color:#17181a}" +
    ".legit-cart-gift__h b{color:#c7352c;font-weight:900}" +
    ".legit-cart-gift__h s{color:#6c8c39;text-decoration:none;font-weight:900}" +
    ".legit-cart-gift__deal{display:inline-block;margin:0 0 6px;padding:3px 7px;border-radius:5px;background:#17181a;color:#fcb525;font-size:10px;font-weight:900;letter-spacing:.1em;text-transform:uppercase}" +
    ".legit-cart-gift__track{position:relative;height:30px;margin:10px 16px 0 0}" +
    ".legit-cart-gift__rail{position:absolute;left:0;right:0;top:11px;height:8px;border-radius:999px;background:#f0dcc0}" +
    ".legit-cart-gift__fill{position:absolute;left:0;top:11px;height:8px;border-radius:999px;background:linear-gradient(90deg,#fcb525,#f0483e);transition:width .35s ease}" +
    ".legit-cart-gift__mk{position:absolute;top:0;width:30px;height:30px;margin-left:-15px;border-radius:50%;background:#fff;border:2px solid #f0dcc0;box-sizing:border-box;display:grid;place-items:center;overflow:hidden}" +
    ".legit-cart-gift__mk img{width:24px;height:24px;object-fit:contain}" +
    ".legit-cart-gift__mk--ship.is-hit{background:#fcb525;border-color:#fcb525}" +
    ".legit-cart-gift__mk--gift{border-color:#f0483e}" +
    ".legit-cart-gift__mk.is-hit::after{content:'';position:absolute;right:-2px;bottom:-2px;width:12px;height:12px;border-radius:50%;background:#6c8c39 url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='white' stroke-width='4'%3E%3Cpath d='M5 12l5 5L20 7'/%3E%3C/svg%3E\") center/8px no-repeat}" +
    ".legit-cart-gift__labels{position:relative;height:14px;margin:4px 16px 0 0}" +
    ".legit-cart-gift__lb{position:absolute;transform:translateX(-50%);font-size:10px;font-weight:900;letter-spacing:.08em;text-transform:uppercase;color:#6b6f75;white-space:nowrap}" +
    ".legit-cart-gift__lb--end{left:auto;right:-16px;transform:none}" +
    "@media(max-width:480px){.legit-cart-gift__lbt{display:none}}" +
    ".legit-cart-gift__lb.is-hit{color:#6c8c39}" +
    ".legit-cart-gift__lb--gift{color:#c7352c}" +
    ".legit-cart-gift--done{background:#f0483e;border-bottom:0;padding:11px 16px}" +
    ".legit-cart-gift--done .legit-cart-gift__h{color:#fff;font-weight:900;letter-spacing:.05em;text-transform:uppercase;display:flex;align-items:center;justify-content:center;gap:8px;text-align:center}" +
    ".legit-cart-gift__readd{display:flex;align-items:center;justify-content:space-between;gap:10px;margin-top:10px;padding:8px 10px;border-radius:8px;background:#fff;color:#17181a;font-size:12.5px;font-weight:600;letter-spacing:0;text-transform:none}" +
    ".legit-cart-gift__readd button{flex:none;border:0;border-radius:6px;background:#17181a;color:#fff;font:inherit;font-weight:800;font-size:12px;letter-spacing:.04em;text-transform:uppercase;padding:8px 12px;min-height:34px;cursor:pointer}" +
    "@media(prefers-reduced-motion:reduce){.legit-cart-gift__fill{transition:none}}";

  function injectStyle() {
    if (document.getElementById('legit-cart-gift-style')) return;
    var s = document.createElement('style');
    s.id = 'legit-cart-gift-style';
    s.textContent = STYLE;
    (document.head || document.documentElement).appendChild(s);
  }

  function cart() { try { return (window.Rebuy && Rebuy.Cart && Rebuy.Cart.cart) || null; } catch (e) { return null; } }
  function total(c) {
    if (!c || !Array.isArray(c.items)) return 0;
    if (typeof c.total_price === 'number') return c.total_price;
    return c.items.reduce(function (t, i) { return t + (i.final_line_price || 0); }, 0);
  }
  function freeLine(c, handle) {
    return !!(c && c.items && c.items.some(function (i) { return i.handle === handle && (i.final_line_price || 0) === 0; }));
  }

  // everyone's tiers, plus a gated gift if this visitor came in on its link or already has it free
  function activeTiers(c) {
    return G.tiers.filter(function (t) {
      if (t.always) return true;
      var flag = false;
      try { flag = sessionStorage.getItem('legitGift:' + t.param) === '1'; } catch (e) {}
      return flag || freeLine(c, t.handle);
    });
  }

  function marker(t, hit, left) {
    var inner = t.id === 'ship' ? G.truck(15, hit ? '#17181a' : '#fcb525') : (t.image ? '<img src="' + t.image + '" alt="">' : '');
    return '<span class="legit-cart-gift__mk legit-cart-gift__mk--' + (t.id === 'ship' ? 'ship' : 'gift') + (hit ? ' is-hit' : '') + '" style="left:' + left + '%">' + inner + '</span>';
  }

  function html(tiers, amt, c) {
    var max = tiers[tiers.length - 1].threshold;
    var next = null, got = [];
    tiers.forEach(function (t) { if (amt >= t.threshold) got.push(t); else if (!next) next = t; });
    var done = !next;
    var deal = G.email ? '<span class="legit-cart-gift__deal">Email deal</span><br>' : '';

    var head;
    if (done) {
      head = G.truck(16, '#fff') + got.map(function (t) { return t.done; }).join(' + ') + ' unlocked';
    } else {
      var what = next.id === 'ship' ? 'FREE shipping' : 'a FREE ' + next.name;
      head = deal + (got.length ? '<s>&#10003; ' + got.map(function (t) { return t.done; }).join(' + ') + ' unlocked.</s> ' : '') +
        "You're <b>" + money(next.threshold - amt) + '</b> away from ' + what;
    }

    var track = '', labels = '';
    if (!done) {
      var pct = Math.max(3, Math.min(100, Math.round(amt / max * 100)));
      track = '<div class="legit-cart-gift__track" aria-hidden="true"><span class="legit-cart-gift__rail"></span><span class="legit-cart-gift__fill" style="width:' + pct + '%"></span>';
      tiers.forEach(function (t) {
        var at = Math.round(t.threshold / max * 100);
        track += marker(t, amt >= t.threshold, at);
        var lastOne = t === tiers[tiers.length - 1];
        labels += '<span class="legit-cart-gift__lb' + (t.id !== 'ship' ? ' legit-cart-gift__lb--gift' : '') + (amt >= t.threshold ? ' is-hit' : '') + (lastOne ? ' legit-cart-gift__lb--end' : '') + '"' + (lastOne ? '' : ' style="left:' + at + '%"') + '>' + money(t.threshold) + '<span class="legit-cart-gift__lbt"> ' + t.label + '</span></span>';
      });
      track += '</div>';
      labels = '<div class="legit-cart-gift__labels" aria-hidden="true">' + labels + '</div>';
    }

    // earned gift missing from the cart (binned by the shopper): forward to Rebuy's hidden Re-Add
    var readd = '';
    var missing = got.filter(function (t) { return t.always && t.handle && !freeLine(c, t.handle); });
    if (missing.length && document.querySelector('.rebuy-cart__progress-gift-variant-readd')) {
      readd = '<div class="legit-cart-gift__readd"><span>Your free ' + missing[0].name + " isn't in your cart.</span>" +
        '<button type="button" data-legit-readd>Add it back</button></div>';
    }

    return { done: done, html: '<div class="legit-cart-gift__row"><span class="legit-cart-gift__h">' + head + '</span></div>' + track + labels + readd };
  }

  var observer = null, queued = false, last = '';
  function render() {
    queued = false;
    if (observer) observer.disconnect();
    try {
      var host = document.querySelector('[data-rebuy-component="cart-items"]');
      var box = document.querySelector('[data-legit-cart-gift]');
      var c = cart();
      var hasItems = c && c.items && c.items.length > 0;
      var tiers = activeTiers(c);

      if (host && hasItems && tiers.length) {
        var out = html(tiers, total(c), c);
        if (!box || box.nextElementSibling !== host) {
          if (box) box.remove();
          box = document.createElement('div');
          box.setAttribute('data-legit-cart-gift', '');
          box.setAttribute('role', 'status');
          host.parentNode.insertBefore(box, host);
          last = '';
        }
        if (out.html !== last) {
          box.className = 'legit-cart-gift' + (out.done ? ' legit-cart-gift--done' : '');
          box.innerHTML = out.html;
          last = out.html;
        }
      } else if (box) {
        box.remove();
        last = '';
      }
    } catch (e) {
      if (window.console) console.warn('[legit-gift-cart]', e);
    } finally {
      if (observer) observer.observe(document.body, { childList: true, subtree: true });
    }
  }
  function schedule() {
    if (queued) return;
    queued = true;
    // rAF is paused in background tabs, so fall back to a timer there
    if (document.hidden || !window.requestAnimationFrame) setTimeout(render, 30);
    else window.requestAnimationFrame(render);
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-legit-readd]');
    if (!b) return;
    var re = document.querySelector('.rebuy-cart__progress-gift-variant-readd');
    if (re) { b.disabled = true; b.textContent = 'Adding...'; re.click(); }
  });

  function start() {
    injectStyle();
    observer = new MutationObserver(schedule);
    observer.observe(document.body, { childList: true, subtree: true });
    ['rebuy:cart.ready', 'rebuy:cart.change', 'rebuy:cart.enriched', 'rebuy:smartcart.ready', 'rebuy:smartcart.show']
      .forEach(function (ev) { document.addEventListener(ev, schedule); });
    schedule();
    setTimeout(schedule, 1200);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
